<template>
  <div class="clearfix">
    <el-form-item :label="labelText" class="w315">
      <el-select v-model="form.salesDateType" @change="setFatherValue">
        <el-option
          v-for="item in options"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label=" " class="w150" v-if="form.salesDateType == 'day'">
      <el-input v-model.number="form.day" suffix-icon="el-icon-date" @change="setFatherValue"></el-input>
    </el-form-item>
    <el-form-item label=" " class="w150" v-if="form.salesDateType == 'day'">
      <el-time-select
        v-model="form.hourDate"
        :picker-options="{
          start: '00:00',
          step: '00:30',
          end: '23:59'
        }"
        @change="setFatherValue">
      </el-time-select>
    </el-form-item>

    <el-form-item label=" " class="w150" v-if="form.salesDateType == 'hour'">
      <el-input v-model="form.hour" suffix-icon="hour" @change="setFatherValue"></el-input>
    </el-form-item>

    <el-form-item label=" " class="w150" v-if="form.salesDateType == 'minute'">
      <el-input v-model="form.minute" @change="setFatherValue"><span slot="suffix">{{ $locale("calendar.min") }}</span></el-input>
    </el-form-item>

    <el-form-item label=" " class="w150" v-if="form.salesDateType == 'afterMinute'">
      <el-input v-model="form.minute" @change="setFatherValue"><span slot="suffix">{{ $locale("calendar.min") }}</span></el-input>
    </el-form-item>

    <el-form-item label=" " class="w150" v-if="form.salesDateType == 'date'">
      <el-date-picker
        v-model="form.date"
        value-format="timestamp"
        type="date"
        @change="setFatherValue">
      </el-date-picker>
    </el-form-item>

    <template v-if="form.salesDateType == optionType.DOW">
      <el-form-item label=" " class="w160">
        <el-select v-model="form.actionWeekday" @change="setFatherValue">
          <el-option v-for="week in weekSelectArray" :key="week.value" :value="week.value" :label="week.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=" " class="w120">
      <el-time-select
        v-model="form.actionTime"
        :picker-options="{
          start: '00:00',
          step: '00:30',
          end: '23:59'
        }"
        @change="setFatherValue">
      </el-time-select>
      </el-form-item>
      <el-form-item label=" " class="w100">
        <el-select v-model="form.targetDays" @change="setFatherValue">
          <el-option v-for="targetDay in targetDaysArray" :key="targetDay.value" :value="targetDay.value" :label="targetDay.label"></el-option>
        </el-select>
      </el-form-item>
    </template>
  </div>
</template>

<script>
import { weekSelectArray2 } from "@/utils/common";
import { NumberVa } from "@/utils/inputValidation"

export default {
  name: "ruleTemplateTimeItem",
  data() {
    // B/E accept "1-7" to present "Mon-Sun"
    const _targetIndex = weekSelectArray2.findIndex(__item => __item.key === "SUN");
    let _weekArray = [ ...weekSelectArray2 ];

    if (_targetIndex !== "undefined") {
      _weekArray[_targetIndex].value = 7;
    }

    return {
      form: {
        date: this.$moment().valueOf(),
        day: 0,
        hour: 0,
        hourDate: "00:00",
        minute: 0,
        salesDateType: "",
        actionWeekday: 7,
        actionTime: "00:00",
        targetDays: 7,
      },
      optionType: {
        DOW: "actionDay",
      },
      weekSelectArray: _weekArray,
    };
  },
  computed: {
    targetDaysArray() {
      const _resultArray = [];

      for (let i = 7; i <= 30; i++) {
        _resultArray.push({
          label: `${i}${this.$locale("global.day")}`,
          value: i,
        });
      }

      return _resultArray;
    },
  },
  methods: {
    setFatherValue() {
      if (this.form.salesDateType == "day" && this.form.hourDate == null) {
        this.form = { ...this.form, hourDate: "00:00" };
      } else if (this.form.salesDateType !== "day") {
        this.form = {
          ...this.form,
          day: 0,
        };
      } else if (this.form.salesDateType === "day") {
        this.form = {
          ...this.form,
          minute: 0,
        };
      }

      this.$emit("setValue", this.keyName, { ...this.form });
    },
    validateHandler(val) {
      this.form.day = NumberVa(val)
    }
  },
  mounted() {
    // let today = this.$moment().format("YYYY-MM-DD");

    // today = this.$moment(today).valueOf();

    // this.form = {
    //   ...this.form,
    //   date: today,
    // };
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
    keyName: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    labelText: {
      type: String,
      default: "",
    },
  },
  watch: {
    formObj(_nv) {
      const _formObj = { ..._nv };
      this.form = { ...this.form, ..._formObj };
      if (!_formObj.actionTime) {
        this.form.actionTime = "00:00";
      }
    },
  },
};
</script>
